// API Configuration for CordiantOne NO-WAIT
export const API_CONFIG = {
  // Base API URLs - Use proxy in development, full URL in production
  baseURL: import.meta.env.VITE_API_BASE_URL,
  

  // Authentication Configuration
  auth: {
    magicLinkTTL: 300000, // 5 minutes
    sessionTimeout: 3600000, // 1 hour
    endpoints: {
      sendMagicLink: '/auth/send-magic-link',
      verifyMagicLink: '/auth/verify-magic-link',
      refreshToken: '/auth/refresh-token',
      logout: '/auth/logout'
    }
  },

  // Hotel/Tenant Configuration
  hotels: {
    endpoints: {
      getTenantInfo: (hotelSlug: string) => `/hotels/${hotelSlug}/getTenantInfo`
    }
  },

  // Environment flags
  isDevelopment: import.meta.env.DEV,
  
  // Security Configuration
  security: {
    apiTimeout: 90000, // 30 seconds
    maxRetries: 3,
    rateLimitWindow: 90000, // 1 minute
    rateLimitMax: 100 // requests per window
  }
};

// Extract hotel slug from subdomain
export const getHotelSlugFromDomain = (): string => {
  // For development, check if we're on localhost with subdomain
  if (API_CONFIG.isDevelopment) {
    const hostname = window.location.hostname;
    
    // Check for subdomain pattern: subdomain.localhost:3000 or subdomain.localhost
    if (hostname.includes('.localhost')) {
      const subdomain = hostname.split('.localhost')[0];
      if (subdomain && subdomain !== 'localhost') {
        console.log(`🏨 Detected hotel slug from subdomain: ${subdomain}`);
        return `${subdomain}`;
      }
    }
    return 'zenpacorlando'; // Default for localhost without subdomain
    // For localhost without subdomain, use default
    // console.log('🏨 No subdomain detected, using default hotel slug');
    // return 'serenity';
  }
  
  // For production, extract from actual domain
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  if (parts.length >= 3) {
    // subdomain.domain.com
    const subdomain = parts[0];
    console.log(`🏨 Detected hotel slug from production domain: ${subdomain}`);
    return `${subdomain}`;
  }
  
  // Fallback for production
  //console.warn('🏨 Could not detect hotel slug from domain, using fallback');
  //return 'default-hotel';
  return 'zenpacorlando'; // Default for production if no subdomain
};

// Validate required environment variables
export const validateConfig = () => {
  const required = [
    'VITE_API_BASE_URL'
  ];

  const missing = required.filter(key => !import.meta.env[key]);
  
  if (missing.length > 0) {
    console.warn('Missing required environment variables:', missing);
  }
};